/**
 * Category PropTypes
 *
 * PropType definitions for product categories
 *
 * @module propTypes/common/category
 */

import PropTypes from "prop-types";

/**
 * Category PropType
 * Product category shape
 *
 * @property {string} name - Category name (required)
 * @property {string} slug - URL slug (required)
 */
const categoryPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
});

export default categoryPropType;
